import { render } from "./ImageForm.vue?vue&type=template&id=ccd469c8&scoped=true"
import script from "./ImageForm.vue?vue&type=script&lang=js"
export * from "./ImageForm.vue?vue&type=script&lang=js"

import "./ImageForm.vue?vue&type=style&index=0&id=ccd469c8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd469c8"]])

export default __exports__